import { render, staticRenderFns } from "./income_bak.vue?vue&type=template&id=1bde93f1&scoped=true"
import script from "./income_bak.vue?vue&type=script&lang=js"
export * from "./income_bak.vue?vue&type=script&lang=js"
import style0 from "./income_bak.vue?vue&type=style&index=0&id=1bde93f1&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde93f1",
  null
  
)

export default component.exports